import React, { useContext, useEffect, useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useLocation } from "react-router-dom";

import SignInSideCurtains from "../../components/SignInSideCurtains/SignInSideCurtains";
import SignUpSideCurtains from "../../components/SignUpSideCurtains/SignUpSideCurtains";
import AuthContext from "../../store/auth-context";
import CloseSvg from "../../resources/icons/x-close.svg";

function LoginModel({ TriggerBtn, TriggerModuleBtnFromModule }) {
  const [isOpen, setIsOpen] = useState(TriggerBtn);
  const [, setIsMessage] = useState(false);

  const authContext = useContext(AuthContext);
  const location = useLocation();

  function closeModal() {
    setIsOpen(false);
    TriggerModuleBtnFromModule();
    localStorage.removeItem("redirectAfterLogin");
  }

  function toggleComponent() {
    authContext.chooseSignUp_SignIn(!authContext.signOrSignUp);
  }
  useEffect(() => {
    setIsOpen(TriggerBtn);
  }, [TriggerBtn]);

  function toggleIsMessage() {
    setIsMessage((prev) => !prev);
  }

  useEffect(() => {
    if (authContext.signOrSignUp) {
      setIsMessage(false);
    }
    authContext.isSignUpHandler(authContext.signOrSignUp);
  }, [authContext.signOrSignUp, authContext.isSignUpHandler]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const redirectPath = searchParams.get("redirect");

    if (redirectPath) {
      localStorage.setItem("redirectAfterLogin", redirectPath);
    }
  }, [location]);

  return (
    <div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative h-screen z-20"
          onClose={closeModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-200"
            leave="ease-in-out"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-auto ">
            <div className="flex min-h-full items-center text-center justify-center my-2">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-200 transform"
                leave="transition ease-in-out transform"
              >
                <Dialog.Panel className="flex m-auto rounded-[1.25rem] max-w-xl transform bg-cfSecondary text-left align-middle shadow-xl transition-all relative">
                  <div className=" absolute top-12 right-0 px-8">
                  <button
                      onClick={closeModal}
                      className="size-6 cursor-pointer focus:outline-none"
                      aria-label="Close modal"
                    >
                      <img src={CloseSvg} alt="" />
                    </button>
                  </div>
                  <div className="mt-5">
                    {authContext.signOrSignUp ? (
                      <SignInSideCurtains
                        closeModal={closeModal}
                        toggleComponent={toggleComponent}
                      />
                    ) : (
                      <SignUpSideCurtains
                        closeModal={closeModal}
                        toggleComponent={toggleComponent}
                        toggleIsMessage={toggleIsMessage}
                      />
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
export default LoginModel;
